<script setup>

</script>
<template>
	<ul class="mb-4 mt-0 p-0">
		<li><span><img src="/wp-content/themes/vetted-biz/assets/img/check-cff.png" alt="check" /></span>Personalized recommendations</li>
		<li><span><img src="/wp-content/themes/vetted-biz/assets/img/check-cff.png" alt="check" /></span>Support throughout every stage</li>
		<li><span><img src="/wp-content/themes/vetted-biz/assets/img/check-cff.png" alt="check" /></span>No cost to you</li>
		<li><span><img src="/wp-content/themes/vetted-biz/assets/img/check-cff.png" alt="check" /></span>Save time and avoid costly mistakes</li>
	</ul>
</template>
<style>
 ul {
	 list-style: none;
 }
 ul li {
	 font-size: 14px;
 }
</style>